export default __webpack_public_path__ + "static/media/map-pin-solid.b49453d4.svg";